var map = {
	"./icon-marker-bar-small.svg": 40808,
	"./icon-marker-bar.svg": 14370,
	"./icon-marker-cafe-small.svg": 8318,
	"./icon-marker-cafe.svg": 83260,
	"./icon-marker-circle.svg": 11015,
	"./icon-marker-gas_station-small.svg": 52121,
	"./icon-marker-gas_station.svg": 31627,
	"./icon-marker-iqos-small.svg": 40173,
	"./icon-marker-iqos.svg": 48975,
	"./icon-marker-store-small.svg": 44068,
	"./icon-marker-store.svg": 92350
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15397;